import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {CreateEditITApplicationModal} from '@ey/canvascoreservices';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource} from '../../../util/utils';
import {controlType, entities, formBodyType} from '../../../util/uiconstants';
import {clearErrors} from '../../../actions/erroractions';
import {
	createItApplicationSO,
	getITAppSoById,
	updateItApplication
} from '../../../actions/ITApplication/itapplicationaction';
import Utility from '../../../util/utilityfunctions';
import {getAllScots} from '../../../actions/scots/scotsactions';
import {getClientFiltersForBodyType} from '../CanvasForm/Bodies/BodyTypes/BodySpecial/Common/clientFilters.utils';

export default function CreateEditITApplicationModalWrapper(props) {
	const {bodyId, entityId, isCreate, isEdit, showModal, setShowModal, onClose, onSaveComplete, isStandalone} = props;

	const [engagementId] = useSelector((state) => [Number(state.engagementId)]);
	const scots = useSelector((state) => Object.values(state.bodiesSpecial?.scots.byId));
	const itApplication = useSelector((state) => state.bodiesSpecial?.itApplications?.byId[entityId]);
	const controls = useSelector((state) => Object.values(state.bodiesSpecial?.controls.byId));
	const dispatch = useDispatch();

	const filteredScots = scots.filter((scot) => scot.hasNoITApplication !== true);
	const filteredControls = controls.filter(
		(control) =>
			control.controlTypeId !== controlType.manualDetect || control.controlTypeId !== controlType.manualPrevent
	);

	const scotList = {
		data: filteredScots.map((scot) => ({
			...scot,
			controls: scot.controls.map((id) => {
				let control = filteredControls.find((c) => c.id === id);
				return control;
			})
		}))
	};

	const itApplicationDetails = {
		data: [
			{
				...itApplication,
				scots: itApplication?.scots?.map((id) => {
					let scot = scots.find((s) => s.id === id);
					return {
						...scot,
						scotId: scot.id
					};
				}),
				controls: itApplication?.controls?.map((id) => {
					let control = filteredControls.find((c) => c.id === id);
					return control;
				})
			}
		]
	};

	useEffect(() => {
		if (isStandalone) {
			dispatch(
				getAllScots(
					engagementId,
					{
						bodyId: 'custom',
						bodyTypeId: formBodyType.ISA315ItApplicationScot,
						entityId: entities.SCOT,
						clientFilters: {...getClientFiltersForBodyType(formBodyType.ISA315ItApplicationScot)}
					},
					{
						includeControl: true,
						filterControlType: controlType.itApplicationControl + ',' + controlType.itDependentManualControl,
						includePagination: false
					}
				)
			);
		}
	}, [bodyId, dispatch, engagementId, isStandalone]);

	return (
		<>
			{isCreate && (
				<CreateEditITApplicationModal
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditITApplicationLabels}
					engagementId={engagementId}
					scots={scotList}
					createITApplicationAction={(data) => {
						return dispatch(createItApplicationSO(engagementId, data)).then(() => onSaveComplete && onSaveComplete());
					}}
					clearITApplication={() => {
						dispatch(clearErrors());
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					theme={Utility.getTheme()}
				/>
			)}
			{isEdit && (
				<CreateEditITApplicationModal
					engagementId={engagementId}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditITApplicationLabels}
					scots={scotList}
					itApplicationId={itApplicationDetails.data[0].id}
					getITApplicationById={() =>
						getITAppSoById(engagementId, itApplicationDetails.data[0].id, {
							includePagination: false
						})
					}
					itApplicationDetails={itApplicationDetails}
					editITApplicationAction={(id, data) => {
						return dispatch(updateItApplication(engagementId, id, data)).then(() => onSaveComplete && onSaveComplete());
					}}
					clearITApplication={() => {
						dispatch(clearErrors());
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					theme={Utility.getTheme()}
				/>
			)}
		</>
	);
}

CreateEditITApplicationModalWrapper.propTypes = {
	isCreate: PropTypes.bool,
	isEdit: PropTypes.bool,
	showModal: PropTypes.bool.isRequired,
	setShowModal: PropTypes.func.isRequired,
	entityId: PropTypes.number,
	onClose: PropTypes.func
};
